<template>
    <div v-if="items.length !=0">
        <div class="orders">
            <h4 class="orders__label text-orange">A decorrer</h4>

            <ul class="orders__list">
                <li v-for="item in items" :key="item.id" class="in-progress">
                    <div class="orders__list-header">
                        <div class="orders__list-header-group">
                            <h4>{{ item.date }}</h4>
                            <p>{{ item.label_address }} - {{item.price}}€</p>
                        </div>
                        <div class="flex">
                            <button class="btn--outlined--occurrence border-none" @click="handleOccurrencesModal(item.id, item.store_id)">
                                Obter ajuda
                            </button>
                            <button class="btn sm:hidden md:block" @click="handleModal(item.id)">
                                Ver estado do pedido
                            </button>
                        </div>
                    </div>

                    <div class="orders__list-footer">
                        <ul>
                            <li v-for="listItem in item.choices" :key="listItem.product_name">
                                <h5 class="text-orange">
                                    {{listItem.qty}} x {{listItem.product_name}}
                                </h5>
                            </li>
                        </ul>
                    </div>

                    <button class="btn btn--full md:hidden" @click="handleModal(item.id)">
                        Ver estado do pedido
                    </button>
                </li>
            </ul>
        </div>

        <occurrences-modal
            v-if="showOccurenceModal"
            @cancel="showOccurenceModal = false"
            :orderId="orderId"
            :storeId="storeId"
            :externalClientId="externalClientId"
            :phoneCode="phoneCode"
            :phoneNumber="phoneNumber"
            :userName="userName"
        />

        <!-- Modal -->
        <div v-if="modalBox" class="toggle-alert--progress-modal" :class="{'toggle-alert' : modalBox}">
            <div class="modal-content">
                <div id="progress-modal" class="progress-modal card bg-orange-gradLight">
                    <button class="btn-close" @click="handleCloseModal">
                        <img :src="icClose" alt="close">
                    </button>

                    <h3 class="text-center text-orange">
                        Acompanha o estado do teu pedido
                    </h3>

                    <img v-if="trackingStatus === 0" :src="icFish" alt="Estamos a apanhar o peixe">
                    <img v-if="trackingStatus === 1" :src="icSushiMan" alt="sushiman em ação">
                    <img v-if="trackingStatus === 2" :src="icPackaging" alt="A preparar o envio">
                    <img v-if="trackingStatus === 3" :src="icEstafeta" alt="Estafeta a caminho">
                    <img v-if="trackingStatus === 4" :src="icPedidoEntregue" alt="Pedido entregue!">

                    <div class="progress-bar">
                        <span v-if="trackingStatus === 0" style="width: 25%;"></span>
                        <span v-if="trackingStatus === 1" style="width: 45%;"></span>
                        <span v-if="trackingStatus === 2" style="width: 75%;"></span>
                        <span v-if="trackingStatus === 3" style="width: 93%;"></span>
                        <span v-if="trackingStatus === 4" style="width: 100%;"></span>
                    </div>

                    <h4 v-if="trackingStatus === 0" class="text-center">Estamos a apanhar o peixe</h4>
                    <h4 v-if="trackingStatus === 1" class="text-center">sushiman em ação</h4>
                    <h4 v-if="trackingStatus === 2" class="text-center">A preparar o envio</h4>
                    <h4 v-if="trackingStatus === 3" class="text-center">Estafeta a caminho</h4>
                    <h4 v-if="trackingStatus === 4" class="text-center">Pedido entregue!</h4>

                    <p v-if="trackingTime">
                        Chegada à tua morada prevista para as {{ trackingTime }}.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import icClose from '../../../svg/ic_close_orange.svg';
import icFish from '../../../svg/ic_apanhar_peixe.svg';
import icSushiMan from '../../../svg/ic_sushiman.svg';
import icPedidoEntregue from '../../../svg/ic_pedido_entregue.svg';
import icPackaging from '../../../svg/ic_packaging.svg';
import icEstafeta from '../../../svg/ic_estafeta.svg';

import OccurrencesModal from '../modals/occurrences-modal.vue';

export default {
    components: {
        OccurrencesModal,
    },
    props: {
        items: {
            required: true
        },
        externalClientId: {
            required: true,
        },
        phoneCode: {
            required: true,
        },
        phoneNumber: {
            required: true,
        },
        userName: {
            required: true,
        }
    },
    data() {
        return{
            requestStatus:'',
            icFish: icFish,
            icSushiMan: icSushiMan,
            icPedidoEntregue: icPedidoEntregue,
            icPackaging: icPackaging,
            icEstafeta:icEstafeta,
            icClose: icClose,
            modalBox:false,
            trackingStatus:null,
            trackingTime:null,
            showOccurenceModal: false,
            orderId: null,
            storeId: null,
        }
    },
    methods: {
        handleOccurrencesModal(orderId, storeId) {
            this.showOccurenceModal = true;
            this.orderId = orderId;
            this.storeId = storeId;
        },
        bodyOverflow() {
            document.querySelector('html').classList.toggle('no-scroll');
            document.querySelector('body').classList.toggle('no-scroll');
        },
        handleModal(id){
            this.modalBox = !this.modalBox;
            this.bodyOverflow();

            this.$axios.get('/minhas-encomendas/'+id)
                .then((response) => {
                    const { status, tracking_time } = response.data.data;

                    this.trackingTime = tracking_time;
                    this.trackingStatus = status;
                })
                .catch((error) => {
                    switch (error.response.status) {
                        case 401:
                            break;
                        case 404:
                            break;
                        case 422:
                            break;
                        default:
                            //if error 500 => generic error
                            //TODO
                        break;
                    }
                });
        },
        handleCloseModal() {
            this.modalBox = false;

            this.trackingStatus = null;

            this.trackingTime = null;

            this.bodyOverflow();
        }
    },
}
</script>
